import { useState, useEffect } from 'react';
import { Storage } from '../storage';
import DevBlogPost from './DevBlogPost';

const stripHtml = (html) => html.replace(/<[^>]+>/g, '');

const DevBlogFeed = ({ initialPostId, onMounted }) => {
  const [posts,       setPosts]       = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [hasMore,     setHasMore]     = useState(false);
  const [page,        setPage]        = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [selected,    setSelected]    = useState(null);

  useEffect(() => {
    Storage.getDevBlogPosts({ page: 1 })
      .then(({ posts, hasMore }) => {
        setPosts(posts);
        setHasMore(hasMore);
        if (initialPostId) {
          const found = posts.find(p => p.id === initialPostId);
          if (found) {
            setSelected(found);
          } else {
            Storage.getDevBlogPost(initialPostId).then(setSelected).catch(() => {});
          }
        }
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
        onMounted?.();
      });
  }, []);

  const selectPost = (post) => {
    setSelected(post);
    window.history.pushState({}, '', `/dev-blog/${post.id}`);
  };

  const goBack = () => {
    setSelected(null);
    window.history.pushState({}, '', '/dev-blog');
  };

  const loadMore = () => {
    if (loadingMore || !hasMore) return;
    const next = page + 1;
    setLoadingMore(true);
    Storage.getDevBlogPosts({ page: next })
      .then(({ posts: more, hasMore: moreLeft }) => {
        setPosts(prev => [...prev, ...more]);
        setHasMore(moreLeft);
        setPage(next);
      })
      .catch(() => {})
      .finally(() => setLoadingMore(false));
  };

  if (selected) {
    return <DevBlogPost post={selected} onBack={goBack} />;
  }

  if (loading) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        {[0, 1, 2].map(i => (
          <div key={i} style={{
            background: 'var(--surface)', border: '1px solid var(--border)',
            borderRadius: 'var(--radius-xl)', overflow: 'hidden',
            animation: 'pulse 1.6s ease-in-out infinite', animationDelay: `${i * 0.15}s`,
          }}>
            <div style={{ height: 120, background: 'var(--bg2)' }} />
            <div style={{ padding: 20, display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div style={{ height: 16, width: '60%', background: 'var(--bg2)', borderRadius: 4 }} />
              <div style={{ height: 12, width: '80%', background: 'var(--bg2)', borderRadius: 4 }} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!posts.length) {
    return (
      <div style={{ textAlign: 'center', padding: '80px 0', color: 'var(--text3)' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>📝</div>
        <p style={{ fontSize: 15 }}>No dev blog posts yet.</p>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        {posts.map(post => {
          const excerpt = stripHtml(post.body);
          const date = new Date(post.created_at).toLocaleDateString('en-US', {
            year: 'numeric', month: 'short', day: 'numeric',
          });
          return (
            <button
              key={post.id}
              onClick={() => selectPost(post)}
              style={{
                display: 'block', width: '100%', textAlign: 'left',
                background: 'var(--surface)', border: '1px solid var(--border)',
                borderRadius: 'var(--radius-xl)', overflow: 'hidden',
                cursor: 'pointer', padding: 0, transition: 'border-color 0.15s, box-shadow 0.15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.1)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.boxShadow = 'none'; }}
            >
              {post.cover_image && (
                <img
                  src={post.cover_image}
                  alt=""
                  style={{ width: '100%', height: 200, objectFit: 'cover', display: 'block' }}
                />
              )}
              <div style={{ padding: '18px 20px' }}>
                <p style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 6, fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                  {date} · {post.author_name}
                </p>
                <h2 style={{
                  fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 700,
                  color: 'var(--text)', marginBottom: 8, lineHeight: 1.3,
                }}>
                  {post.title}
                </h2>
                <p style={{ fontSize: 14, color: 'var(--text2)', lineHeight: 1.6, margin: 0 }}>
                  {excerpt.slice(0, 150)}{excerpt.length > 150 ? '…' : ''}
                </p>
              </div>
            </button>
          );
        })}
      </div>

      {hasMore && (
        <div style={{ textAlign: 'center', marginTop: 28 }}>
          <button className="btn-ghost" onClick={loadMore} disabled={loadingMore}>
            {loadingMore ? 'Loading…' : 'Load more'}
          </button>
        </div>
      )}
    </div>
  );
};

export default DevBlogFeed;
